import { Injectable } from '@angular/core';
import { Subject, Observable } from 'rxjs';
import { ConstantsService } from '../services/Constants/constants.service';
import { HttpHeaders, HttpClient } from '@angular/common/http';
import { map } from 'rxjs/operators';
import { Consent } from '../classes/Consent';

@Injectable({
  providedIn: 'root'
})
export class ConsentService {
  private service_URL: any;
  transportDetails:any;
  private _refreshPage = new Subject<void>();
  private _refreshwithFilters = new Subject<void>();
  get refreshPage() {
    return this._refreshPage;
  }
  get refreshwithFilters()
  {
     return this._refreshwithFilters;
  }
  constructor(private httpClient: HttpClient) {
    this.service_URL = ConstantsService;
  }
  globalHeaders(): any {
    //   let headers = new HttpHeaders({
    //     'Content-Type': 'application/json'            
    //  });
    let headers: HttpHeaders = new HttpHeaders();
    headers.append('Content-Type', 'application/json');
    headers.append('Access-Control-Allow-Origin', '*');
    headers.append('Access-Control-Allow-Methods', 'GET,PUT,POST,DELETE');
    headers.append('Access-Control-Allow-Headers', 'Content-Type');
    let options = { headers: headers };
    return options;

  }
  
  getConsentDetailsById(id:number) : Observable<any>
  {
      return this.httpClient.get(this.service_URL.Consent.getconsentTableData+id,{headers: <HttpHeaders> new HttpHeaders() }).pipe(map((response) => {
      return response;
    }));    
  }
  //Get user by id
  getDetailsByconsentId(id:number) : Observable<any>
  {
      return this.httpClient.get(this.service_URL.Consent.getConsentById+id,{headers: <HttpHeaders>  new HttpHeaders() }).pipe(map((response) => {
      return response;
    }));    
  }
}
